
export enum ApplicationTokens {
    JMS = 'JMS',
    ID = 'ID',
    Console = 'Console',
    Compliance = 'Compliance',
    JmsWorker = 'ActivityWorker',
    PdfWorker = 'PDF',
    Portal = 'Portal',
    GlobalWorker = 'GlobalWorker',

    Functions = 'Functions',
    FunctionZip = 'FunctionZip',
    FunctionCopyBlob = 'FunctionCopyBlob',

    MicroservicePricing = 'Pricing',
    MicroserviceConnect = 'Connect',
    MicroserviceSideEffects = 'SideEffects',

    CustomisationAssett = 'CustomisationAssett',
}
